import { useNavigate } from "@tanstack/react-router";

import { useCreateReservoir } from "@/lib/api/reservoirs";
import { newULID } from "@/lib/api/client";
import { ErrorState } from "@/components/error-state";

import {
  ReservoirForm,
  emptyToUndef,
  parseOptNum,
  type ReservoirFormValues,
} from "./form";

export function ReservoirNewPage() {
  const navigate = useNavigate();
  const create = useCreateReservoir();

  function submit(values: ReservoirFormValues) {
    create.mutate(
      {
        id: newULID(),
        name: values.name,
        container_type: values.container_type,
        inside_l_in: parseOptNum(values.inside_l_in),
        inside_w_in: parseOptNum(values.inside_w_in),
        inside_h_in: parseOptNum(values.inside_h_in),
        cross_section_in2: parseOptNum(values.cross_section_in2),
        gal_per_inch: parseOptNum(values.gal_per_inch),
        cm_per_gal: parseOptNum(values.cm_per_gal),
        notes: emptyToUndef(values.notes),
      },
      {
        onSuccess: (created) =>
          navigate({
            to: "/reservoirs/$reservoirId",
            params: { reservoirId: created.id },
          }),
      },
    );
  }

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">New reservoir</h1>
      <ReservoirForm
        submitting={create.isPending}
        onSubmit={submit}
        submitLabel="Create"
        banner={
          create.error ? (
            <ErrorState error={create.error} retry={() => create.reset()} />
          ) : undefined
        }
      />
    </div>
  );
}
